import $ from 'jquery';

const float = () => {
  const $float = $('.js-float');
  const footer = document.querySelector('footer');
  
  // 要素が存在しない場合は早期リターン
  if (!$float.length || !footer) return;


  // IntersectionObserver
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        $float.fadeOut();
      } else {
        $float.fadeIn();
      }
    });
  }, {
    root: null,
    threshold: 0,
    rootMargin: '0px' // 必要に応じて調整可能
  });

  observer.observe(footer);
  
  // クリーンアップ用に返す（オプション）
  return () => observer.disconnect();
}

export default float;